/**
 * Textarea — peer of <Input>. Same visual language.
 */

import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'w-full px-4 py-3 rounded-xl transition-all duration-200',
        'bg-white dark:bg-neutral-900',
        'text-neutral-900 dark:text-neutral-100',
        'placeholder:text-neutral-400 dark:placeholder:text-neutral-500',
        'border border-neutral-300 dark:border-neutral-700',
        'hover:border-neutral-400 dark:hover:border-neutral-600',
        'focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 dark:focus:border-primary-400',
        'disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-neutral-50 dark:disabled:bg-neutral-800',
        'aria-[invalid=true]:border-destructive aria-[invalid=true]:focus:ring-destructive/20 aria-[invalid=true]:focus:border-destructive',
        'resize-y min-h-[88px]',
        className
      )}
      {...props}
    />
  )
);
Textarea.displayName = 'Textarea';

export default Textarea;
